import { render } from "./ListNotices.vue?vue&type=template&id=743f4370"
import script from "./ListNotices.vue?vue&type=script&lang=js"
export * from "./ListNotices.vue?vue&type=script&lang=js"

import "./ListNotices.vue?vue&type=style&index=0&id=743f4370&lang=less"
script.render = render

export default script